module.exports = __webpack_public_path__ + "fonts/inter-v3-latin-ext_latin-900.1a1c55b.ttf";